<template>
  <div class="historyWrap">
    <h1 class="title">HISTORY</h1>
    <history-item-list v-if="historyItemList !== undefined"/>
  </div>
</template>

<script>
    import HistoryItemList from '@/components/menu/Sunnyfactory/HistoryItemList'
    import { mapGetters } from 'vuex'

    export default {
        name: "history" ,
        components : {
          'history-item-list' : HistoryItemList,
        },
        computed : {
          ...mapGetters({
            historyItemList : 'historyStore/getHistories'
          })
        },
        created () {
          this.$store.dispatch('historyStore/getHistories')
        },
        data () {
          return {
            /*historyItemList : [
              {
                id: 1,
                date : '2017.04.08' ,
                title : '써니팩토리 Start' ,
                subTitle : '' ,
              },
              {
                id: 2,
                date : '2017.05.25' ,
                title : '2018 평창동계올림픽대회' ,
                subTitle : '공모전 1차 합격' ,
              },
              {
                id: 3,
                date : '2017.06.15' ,
                title : '정보통신산업진흥원' ,
                subTitle : 'SW스타트업 창업지원 선정' ,
              },
              {
                id: 4,
                date : '2017.07.01' ,
                title : '최초 상용화 프로젝트' ,
                subTitle : 'SunnyERP 개발진행(10~12월)' ,
              },
              {
                id: 5,
                date : '2017.08.03' ,
                title : '한국소프트웨어산업협회' ,
                subTitle : 'SW사업자등록' ,
              },
              {
                id: 6,
                date : '2017.08.21' ,
                title : 'Global 소셜네트워크' ,
                subTitle : '전인지프로미국팬클럽사이트개발완료(8~9월)' ,
              },

            ] ,*/
          }
        }
    }
</script>

<style scoped lang="scss">
  @import "@/styles/Sunnyfactory.scss";
</style>



// WEBPACK FOOTER //
// src/components/menu/Sunnyfactory/History.vue